import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';

/** Danh sách trường (khách hàng) + tra tên theo mã — dùng cho cột "Tên trường học" và dropdown. */
const useConfirmationClients = () => {
  const service = useService();

  const { data: clients = [] } = useQuery({
    queryKey: [KEYS_QUERY.kiosClients, 'confirmation-code'],
    queryFn: async () => {
      if (!service) return [];
      return (await service.KiosController_listClients()) ?? [];
    },
    staleTime: 5 * 60 * 1000,
    // BẮT BUỘC: thiếu guard này, render đầu (service chưa sẵn) sẽ cache [] suốt staleTime
    // → cột "Tên trường học" hiện trơ mã CĐS và dropdown chọn trường ở màn Thêm bị rỗng.
    enabled: !!service,
  });

  const nameOf = (code?: string) =>
    (code && clients.find((c) => c.operationCode === code)?.name) || code || '';

  return { clients, nameOf };
};

export default useConfirmationClients;
